/**
 * Gate for the web FTUE. ON by default (verified live on bolshoi rc60). The FTUE only
 * shows to genuine first-time users (0 real playbooks) who hold the required permissions,
 * so the default-on gate can't take over an existing user's session.
 *
 * Escape hatch: set localStorage `bb_enable_web_ftue = "false"` to force it off for a
 * given browser (e.g. to debug the underlying app without the overlay).
 */
export function isWebFtueEnabled(): boolean {
  try {
    return localStorage.getItem('bb_enable_web_ftue') !== 'false';
  } catch {
    return true;
  }
}
